import { render, staticRenderFns } from "./EducationQuiz.vue?vue&type=template&id=5ba49086&scoped=true"
import script from "./EducationQuiz.vue?vue&type=script&lang=js"
export * from "./EducationQuiz.vue?vue&type=script&lang=js"
import style0 from "./EducationQuiz.vue?vue&type=style&index=0&id=5ba49086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba49086",
  null
  
)

export default component.exports